/**
 * The two facts about the stored cookie choice that more than the consent store needs — dependency-free on purpose
 * (no React, no zustand), so that the build tooling can import them: the inline Google Tag Manager consent snippet
 * (`lib/gtm/snippet.ts`, written into every page's `<head>` by the build) reads the same key and version as the store,
 * and `scripts/csp-sweep.ts` seeds a stored choice with them.
 */

/**
 * Which wording the stored choice was made under. The choice is now the visitor's acceptance of the Legal Disclaimer
 * (2: the disclaimer of 18-10-2016, D-372; 1 was the old cookie bar). Bump it — and `LEGAL_DISCLAIMER_VERSION` in
 * `packages/shared` — whenever the disclaimer's text changes, so every visitor accepts the new wording.
 */
export const CONSENT_VERSION = 2;
export const CONSENT_STORAGE_KEY = 'sbg.consent';
